module.exports = __webpack_public_path__ + "media/images/category/shopping-150b3a2ad2fdb99e6ad619499a6734f9.svg";